import { Modal } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import { openChatDrift } from '~/redux-modules/drift'

const PLACEMENT = 'notify-fictiv'
const MODAL_TITLE =
    'Your report contains more than 50 pages and cannot be downloaded at this time. Please contact your Fictiv representative.'

type ContactFictivModalPropsType = {
    onClose: () => void
}

const ContactFictivModal = (props: ContactFictivModalPropsType) => {
    const { onClose } = props

    const dispatch = useDispatch()

    return (
        <Modal
            bodyStyle={{ padding: '24px' }}
            centered
            closable={false}
            footer={null}
            onCancel={onClose}
            visible
        >
            <Box>
                <CheckCircleOutlined
                    style={{
                        color: getColor('success'),
                        fontSize: '21px',
                        marginRight: '16px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        color="blackAlpha65"
                        fontSize="16px"
                        fontWeight={500}
                        style={{ marginBottom: '12px' }}
                    >
                        {MODAL_TITLE}
                    </Text>
                    <Box justifyContent="end">
                        <Button
                            data-test-target={`${PLACEMENT}-cancel`}
                            name={`${PLACEMENT}-cancel`}
                            onClick={onClose}
                            placement={PLACEMENT}
                            style={{ marginRight: '8px', marginLeft: 'auto' }}
                        >
                            Cancel
                        </Button>
                        <Button
                            data-test-target={`${PLACEMENT}-chat-with-us`}
                            name={`${PLACEMENT}-chat-with-us`}
                            onClick={(evt: Event) => {
                                evt.preventDefault()
                                dispatch(openChatDrift())
                            }}
                            placement={PLACEMENT}
                            type="primary"
                        >
                            Chat with us
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}

export default ContactFictivModal
